export default function convertKmToMiles(value) {
    return Math.round(value * 0.621371, 2);
}
